<template>
    <div class="server">
        <div class="swiperOne">
            <img src="@/assets/images/serverSwiperOne.png" alt="">
            <div class="swiperFirst">
                <van-swipe class="my-swipe" :autoplay="3000" indicator-color="#0bb3a0">
                    <van-swipe-item>
                        <img src="@/assets/images/firstSwiper.png" alt="" >
                    </van-swipe-item>
                </van-swipe>
            </div>
        </div>
        <div class="swiperTwo">
            <img src="@/assets/images/serverSwiperTwo.png" alt="">
            <div class="swiperSecond">
                <van-swipe class="my-swipe" :autoplay="3000" indicator-color="#0bb3a0">
                    <van-swipe-item>
                        <img src="@/assets/images/secondSwiper.png" alt="" >
                    </van-swipe-item>
                    <van-swipe-item>
                        <img src="@/assets/images/lectureOne.png" alt="" >
                    </van-swipe-item>
                    <van-swipe-item>
                        <img src="@/assets/images/lectureTwo.png" alt="" >
                    </van-swipe-item>
                    <van-swipe-item>
                        <img src="@/assets/images/lectureThree.png" alt="">
                    </van-swipe-item>
                    <van-swipe-item>
                        <img src="@/assets/images/lectureFour.png" alt="">
                    </van-swipe-item>
                </van-swipe>
            </div>
        </div>
        <div class="swiperThree">
            <img src="@/assets/images/serverSwiperThree.png" alt="">
            <div class="swiperThird">
                <van-swipe class="my-swipe" :autoplay="3000" indicator-color="#0bb3a0">
                    <van-swipe-item>
                        <img src="@/assets/images/thirdSwiper.png" alt="" >
                    </van-swipe-item>
                    <van-swipe-item>
                        <img src="@/assets/images/studiesOne.png" alt="" >
                    </van-swipe-item>
                    <van-swipe-item>
                        <img src="@/assets/images/studiesTwo.png" alt="" >
                    </van-swipe-item>
                    <van-swipe-item>
                        <img src="@/assets/images/studiesThree.png" alt="" >
                    </van-swipe-item>
                </van-swipe>
            </div>
        </div>
        <!-- <div class="serverFour">
            <img src="@/assets/images/serverFour.png" alt="">
        </div> -->
        <Comment></Comment>
    </div>
</template>

<script type="text/ecmascript-6">
import Comment from '@/components/Comment.vue'
export default {
 components: {
    Comment
},
 props: {},
 data () {
     return {

     };
 },
 watch: {},
 computed: {},
 methods: {},
 mounted () {}
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/serve/server.vue